<div>
  <div>{{'Vers_Selec' | translate}} {{getNumVer()}}</div>
</div>
<!-- Dock document : infos, index -->
<p-tabView (onChange)="handleChange($event)" [activeIndex]="viewIndex">
  @if (rightService.typeAction.TDInfo || rightService.typeAction.TDVar || rightService.typeAction.TDCom) {
    <p-tabPanel>
      <ng-template pTemplate="header">{{'Doc_B' | translate}}</ng-template>
      <div class="flex flex-wrap">
        <!-- 1 ere col -->
        <div class="flex flex-wrap flex-column md:flex-wrap"
          [ngClass]="{
          'col-display-1': nbZoneDisplay.nbDocLeft === 1,
          'col-display-2': nbZoneDisplay.nbDocLeft >= 1 && nbZoneDisplay.nbDocRight >= 1,
          'col-display-false': nbZoneDisplay.nbDocLeft === 0
          }">
          <!-- 1er ele -->
          @if (rightService.typeAction.TDInfo) {
            <div class="col-12">
              <displayvalue class="col-12" [title]="'Infos' | translate" [dataLineList]="docInfos" [scroll]="true"></displayvalue>
            </div>
          }
        </div>
        <!-- 2 eme col -->
        <div class="flex flex-wrap flex-column md:flex-wrap"
            [ngClass]="{
            'col-display-1': nbZoneDisplay.nbDocRight === 1,
            'col-display-2': nbZoneDisplay.nbDocLeft >= 1 && nbZoneDisplay.nbDocRight >= 1,
            'col-display-false': nbZoneDisplay.nbDocRight === 0
            }"
          >
          <!-- 1er ele -->
          @if (rightService.typeAction.TDVar) {
            @if (rightService.typeAction.TIdx === true) {
              <div class="col-12">
                <displayvalue class="col-12" [title]="'Index_B' | translate" [dataLineList]="docIndexFiltered" [scroll]="true"></displayvalue>
              </div>
            }
          }
          <!-- 2 eme ele -->
          @if (rightService.typeAction.TDCom) {
            <commentaires class="linepad col-12"
              [docId]="currentDocId"
              [scroll]="true"
              [addComm]="false"
              [addNotif]="false"
            ></commentaires>
          }
        </div>
      </div>
    </p-tabPanel>
  }
  <!-- Dock Traçabilité : traces, circulation -->
  @if (rightService.typeAction.TDTra || rightService.typeAction.TBList) {
    <p-tabPanel>
      <ng-template pTemplate="header">{{'Follow' | translate}}</ng-template>
      <div class="flex flex-wrap">
        <!-- 1 ere col -->
        <div class="flex flex-wrap flex-column md:flex-wrap"
          [ngClass]="{
          'col-display-1': nbZoneDisplay.nbFollowLeft >= 1,
          'col-display-2': nbZoneDisplay.nbFollowLeft >= 1 && nbZoneDisplay.nbFollowRight >= 1,
          'col-display-false': nbZoneDisplay.nbFollowLeft === 0
          }">
          <!-- 1er ele -->
          @if (rightService.typeAction.TDTra) {
            <traces [docId]="currentDocId" [scroll]="true"></traces>
          }
        </div>
      </div>
    </p-tabPanel>
  }
  <!-- Dock version : versions -->
  @if (rightService.typeAction.TGVer) {
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span class="p-tabview-title"
          >{{'Versions' | translate}}
          <span class="p-tabview-title small">({{ docVersion().length }})</span>
        </span>
      </ng-template>
      <versionlist
        [editMode]="true"
        [listVersion]="docVersion"
        [docId]="currentDocId"
        [delVer]="rightService.typeAction.TDel"
        [viewVer]="rightService.typeAction.TGVer"
        [isLock]="isLock"
        (onUpdateVer)="refreshVer($event)"
        (onViewVer)="viewVer($event)"
      ></versionlist>
    </p-tabPanel>
  }
</p-tabView>
